/**
 * ANALYSIS section — the three prose tiers (shortSummary, summary,
 * numberSummary) plus affected concepts, mobile-app style.
 *
 * The severity rating leads the first line as a small coloured label
 * rather than a full-width heading: on a panel opened verse after verse,
 * a large "___ Problem" in the severity colour reads as alarm fatigue.
 */

import type { VariantAnalysis } from '@skjv/common';
import { severityFor } from './severity';

interface AnalysisSummariesProps {
  analysis: VariantAnalysis;
}

export function AnalysisSummaries({ analysis }: AnalysisSummariesProps) {
  const severity = severityFor(analysis.score);

  return (
    <div>
      <p className="verse-analysis-short-summary">
        <span className="verse-analysis-severity-label">{severity.title}</span>
        {analysis.shortSummary}
      </p>
      {analysis.summary && analysis.summary !== analysis.shortSummary && (
        <p className="verse-analysis-summary">{analysis.summary}</p>
      )}
      {analysis.numberSummary && (
        <p className="verse-analysis-number-summary">{analysis.numberSummary}</p>
      )}
      {analysis.affectedConcepts.length > 0 && (
        <p className="variant-concepts">
          Affected concepts: {analysis.affectedConcepts.join(', ')}
        </p>
      )}
    </div>
  );
}
